export const announcements = [
    {
        id: 'app-as-pwa',
        type: 'feature',
        title: 'TaxiFusion als App installieren',
        video: {
            ios: '/feature-announcement/app-as-pwa-ios.mp4',
            android: '/feature-announcement/app-as-pwa-android.mp4',
            default: '/feature-announcement/app-as-pwa.mp4',
        },
        videoPoster: '/feature-announcement/app-as-pwa.png',
        content: `
            <p style="font-size: 1rem; line-height: 1.6; margin-bottom: 16px;">
                TaxiFusion lässt sich jetzt wie eine native App auf Ihrem Smartphone installieren. Kein App Store nötig – einfach installieren und vom Startbildschirm aus nutzen. Funktioniert offline, lädt blitzschnell und bietet Ihnen den vollen Funktionsumfang unserer Web-App.
            </p>
            <p style="font-size: 0.9rem; color: #666; margin-top: 16px;">
                <strong>So geht's:</strong> Öffnen Sie TaxiFusion in Ihrem Browser und folgen Sie den Installationshinweisen. Die Funktion ist auf allen Seiten verfügbar.
            </p>
        `,
        priority: 'high',
        routeNames: ['overview'],
        startDate: '2025-11-07',
        endDate: null,
        showAsModal: false,
    },
    {
        id: 'preiskorrektur-2025',
        type: 'feature',
        title: 'Preiskorrektur – Preise direkt anpassen',
        video: '/feature-announcement/preiskorrektur-trips-shifts.mp4',
        videoPoster: '/feature-announcement/preiskorrektur-trips-shifts.jpg',
        content: `
            <p style="font-size: 1rem; line-height: 1.6; margin-bottom: 16px;">
                Manchmal muss ein Preis nachträglich angepasst werden. Jetzt geht das direkt in Einzelfahrten und Schichten – mit nur einem Klick.
            </p>
            <p style="font-size: 1rem; line-height: 1.6; margin-bottom: 16px;">
                Klicken Sie einfach auf eine Fahrt, passen Sie den Wert an und fertig. Alle Änderungen werden transparent in der Historie dokumentiert, sodass Sie jederzeit nachvollziehen können, was wann angepasst wurde.
            </p>
            <p style="font-size: 0.9rem; color: #666; margin-top: 16px;">
                Verfügbar auf den Seiten <strong>Einzelfahrten</strong> und <strong>Schichten</strong>.
            </p>
        `,
        priority: 'high',
        routeNames: ['trips', 'shifts'],
        startDate: '2025-11-02',
        endDate: null,
        showAsModal: true,
    },
    {
        id: 'app-navigation-toggle',
        type: 'feature',
        title: 'Navigation ein- und ausklappen',
        video: '/feature-announcement/app-navigation-toggle.mp4',
        videoPoster: '/feature-announcement/app-navigation-toggle.jpg',
        content: `
            <p style="font-size: 1rem; line-height: 1.6; margin-bottom: 16px;">
                Mehr Platz für das Wesentliche: Die Navigation lässt sich jetzt ein- und ausklappen. Im eingeklappten Zustand sehen Sie nur noch Icons – alle Funktionen bleiben aber zugänglich.
            </p>
            <ul style="margin: 16px 0; padding-left: 24px; line-height: 1.8;">
                <li>Klicken Sie auf das Menü-Symbol in der Navigation</li>
                <li>Navigation klappt ein – mehr Platz für Ihre Inhalte</li>
                <li>Ihre Einstellung wird automatisch gespeichert</li>
            </ul>
            <p style="font-size: 0.9rem; color: #666; margin-top: 16px;">
                Verfügbar auf <strong>Dashboard</strong>, <strong>Schichten</strong>, <strong>Umsatz</strong> und weiteren Seiten.
            </p>
        `,
        priority: 'high',
        routeNames: ['overview', 'shifts', 'revenue'],
        startDate: '2025-10-23',
        endDate: null,
        showAsModal: false,
    },
    {
        id: 'tables-column-toggle',
        type: 'feature',
        title: 'Tabellenspalten an-/abwählen',
        video: '/feature-announcement/tables-column-toggle.mp4',
        videoPoster: '/feature-announcement/tables-column-toggle.jpg',
        content: `
            <p style="font-size: 1rem; line-height: 1.6; margin-bottom: 16px;">
                Ihre Tabellen, Ihre Regeln. Blenden Sie Spalten nach Bedarf ein oder aus – das Einstellungs-Symbol oben rechts macht's möglich. Einmal konfiguriert, merkt sich TaxiFusion Ihre Präferenzen automatisch.
            </p>
            <p style="font-size: 1rem; line-height: 1.6; margin-bottom: 16px;">
                So sehen Sie immer genau die Informationen, die für Sie relevant sind – ohne Ablenkung durch überflüssige Daten.
            </p>
            <p style="font-size: 0.9rem; color: #666; margin-top: 16px;">
                Diese Funktion finden Sie auf <strong>Einzelfahrten</strong>, <strong>Schichten</strong>, <strong>Betriebsnachweise</strong> und weiteren Seiten.
            </p>
        `,
        priority: 'high',
        routeNames: ['trips', 'shifts', 'operationride'],
        startDate: '2025-10-17',
        endDate: null,
        showAsModal: false,
    },
    {
        id: 'elster-cash-statement',
        type: 'feature',
        title: 'Kassenmeldung beim Finanzamt mit Elster',
        video: '/feature-announcement/elster-cash-statement.mp4',
        videoPoster: '/feature-announcement/elster-cash-statement.jpg',
        content: `
            <p style="font-size: 1rem; line-height: 1.6; margin-bottom: 16px;">
                Ab 2026 ist die TSE-Pflicht für Taxibetriebe gesetzlich vorgeschrieben. TaxiFusion unterstützt Sie dabei mit voller TSE-Kompatibilität und nahtloser Integration in das deutsche Finanzsystem.
            </p>
            <p style="font-size: 1rem; line-height: 1.6; margin-bottom: 16px;">
                <strong>So funktioniert's:</strong>
            </p>
            <p style="font-size: 1rem; line-height: 1.6; margin-bottom: 16px;">
                Navigieren Sie in Ihren Einstellungen zum Bereich „Finanzen" und fordern Sie dort die XML-Datei an. Sie erhalten anschließend eine E-Mail mit der XML-Datei, die Sie direkt in Ihrem Elster-Konto hochladen können. Diese Datei bestätigt Ihre TSE-Kompatibilität gegenüber dem Finanzamt – ganz ohne manuellen Aufwand.
            </p>
            <p style="font-size: 1rem; line-height: 1.6; margin-bottom: 16px;">
                <strong>Ihre Vorteile:</strong>
            </p>
            <ul style="margin: 16px 0; padding-left: 24px; line-height: 1.8;">
                <li>Automatische XML-Generierung nach deutschen Standards</li>
                <li>E-Mail mit direkten Upload-Anweisungen</li>
                <li>Kompatibel mit allen Elster-Konten</li>
            </ul>
        `,
        priority: 'high',
        routeNames: ['settings'],
        routePath: '/settings?tab=finance',
        startDate: '2025-11-08',
        endDate: null,
        showAsModal: false,
    },
];
